import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "19",
  fill: "none",
  viewBox: "0 0 20 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.6",
      d: "M7.5 17.5v-6.166c0-.467 0-.7.091-.879a.83.83 0 0 1 .364-.364c.179-.09.412-.09.879-.09h2.333c.467 0 .7 0 .878.09.157.08.285.208.364.364.091.179.091.412.091.879V17.5m4.167-7.916v5.25c0 .933 0 1.4-.182 1.756-.16.314-.414.569-.728.729-.357.181-.823.181-1.757.181H6c-.933 0-1.4 0-1.756-.181a1.67 1.67 0 0 1-.729-.729c-.181-.356-.181-.823-.181-1.756V6.667l5.066-3.8c.574-.43.861-.645 1.176-.728.278-.074.57-.074.849 0M1.667 7.917 9.2 2.267c.287-.215.43-.323.588-.364a.83.83 0 0 1 .425 0c.157.041.3.149.587.364m5.034 4.4v-2.5m0 0v-2.5m0 2.5h-2.5m2.5 0h2.5"
    }, null, -1)
  ])))
}
export default { render: render }